var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React from 'react';
import styled, { css } from 'styled-components';
import { createSelector } from 'reselect';
import Typography from '../Typography';
import { isPercent } from '@signal/utils/getStringFormatter';
import CircularProgress from '@material-ui/core/CircularProgress';
import { getColorBackgroundSelector, getColorPrimarySelector } from '@signal/theme/selectors';
import TypographySkeleton from '../Skeleton/Typography';

var sizePropSelector = function sizePropSelector(props) {
  return props.size;
};

var fontWeightPropSelector = function fontWeightPropSelector(props) {
  return props.fontWeight;
};

var formatPropSelector = function formatPropSelector(props) {
  return props.format;
};

var fontSizeSelector = createSelector(sizePropSelector, formatPropSelector, function (size, format) {
  var divisor = isPercent(format) ? 4 : 3;
  return Math.round(size / divisor);
});

var fontTransformSelector = function fontTransformSelector(props) {
  var verticalStretch = 1;
  var horizontalStretch = 1;
  var value = props.value;

  if (value && value.length > 3) {
    horizontalStretch = 0.87;
  }

  return "scale(".concat(horizontalStretch, ", ").concat(verticalStretch, ")");
};

var mixinDonutPositioning = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n"])));
export var Wrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  height: ", "px;\n  min-height: ", "px;\n  width: ", "px;\n  min-width: ", "px;\n  position: relative;\n"])), sizePropSelector, sizePropSelector, sizePropSelector, sizePropSelector);
export var OuterDonut = styled(function (_ref) {
  var colored = _ref.colored,
      rest = _objectWithoutProperties(_ref, ["colored"]);

  return /*#__PURE__*/React.createElement(CircularProgress, rest);
}).attrs(function () {
  return {
    variant: 'static',
    value: 100
  };
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n  ", "\n"])), function (props) {
  return props.colored ? getColorPrimarySelector('dark') : getColorBackgroundSelector();
}, mixinDonutPositioning);
export var InnerDonut = styled(CircularProgress).attrs(function () {
  return {
    variant: 'static'
  };
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n  circle {\n    transition-duration: 500ms;\n  }\n"])), mixinDonutPositioning);
export var ValueWrapper = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: ", "px;\n"])), sizePropSelector);
export var Value = styled(function (_ref2) {
  var fontWeight = _ref2.fontWeight,
      format = _ref2.format,
      value = _ref2.value,
      size = _ref2.size,
      rest = _objectWithoutProperties(_ref2, ["fontWeight", "format", "value", "size"]);

  return /*#__PURE__*/React.createElement(Typography, rest);
}).attrs(function (_ref3) {
  var color = _ref3.color;
  return {
    variant: 'subtitle1',
    color: color ? color : null
  };
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-size: ", "px;\n  font-weight: ", ";\n  transform: ", ";\n"])), fontSizeSelector, fontWeightPropSelector, fontTransformSelector);

var getSkeletonVariant = function getSkeletonVariant(size) {
  var variant = 'body1';
  if (size >= 150) variant = 'h1';
  if (size < 150 && size >= 100) variant = 'h2';
  if (size < 100 && size >= 50) variant = 'h4';
  return variant;
};

export var ValueSkeleton = styled(TypographySkeleton).attrs(function (props) {
  return {
    variant: getSkeletonVariant(props.size)
  };
})(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral([""])));